/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicarePtOtMappings } from './MedicarePtOtMappings';
import {
    MedicarePtOtMappingsFromJSON,
    MedicarePtOtMappingsFromJSONTyped,
    MedicarePtOtMappingsToJSON,
    MedicarePtOtMappingsToJSONTyped,
} from './MedicarePtOtMappings';

/**
 * 
 * @export
 * @interface GetMedicarePtOtMappings200Response
 */
export interface GetMedicarePtOtMappings200Response {
    /**
     * 
     */
    data?: MedicarePtOtMappings;
}

/**
 * Check if a given object implements the GetMedicarePtOtMappings200Response interface.
 */
export function instanceOfGetMedicarePtOtMappings200Response(value: object): value is GetMedicarePtOtMappings200Response {
    return true;
}

export function GetMedicarePtOtMappings200ResponseFromJSON(json: any): GetMedicarePtOtMappings200Response {
    return GetMedicarePtOtMappings200ResponseFromJSONTyped(json, false);
}

export function GetMedicarePtOtMappings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMedicarePtOtMappings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MedicarePtOtMappingsFromJSON(json['data']),
    };
}

export function GetMedicarePtOtMappings200ResponseToJSON(json: any): GetMedicarePtOtMappings200Response {
    return GetMedicarePtOtMappings200ResponseToJSONTyped(json, false);
}

export function GetMedicarePtOtMappings200ResponseToJSONTyped(value?: GetMedicarePtOtMappings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MedicarePtOtMappingsToJSON(value['data']),
    };
}

